import { Typography } from "@material-ui/core";
import IntlTelInput from "react-intl-tel-input";
import { parseInternationalPhoneNumber } from "./utils";

export const FormattedNumber = ({ number }) => {
  const { phoneNumber, countryCode } = parseInternationalPhoneNumber(number);
  return (
    <IntlTelInput
      containerClassName="intl-tel-input"
      inputClassName="MuiInputBase-input"
      defaultCountry={countryCode}
      placeholder=""
      allowDropdown={false}
      format
      formatOnInit
      nationalMode
      value={phoneNumber}
      disabled
      readOnly
    />
  );
};
export const columns = [
  {
    heading: "Phone Number",
    renderCell: (contact) => {
      return (
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "flex-start",
          }}
        >
          <FormattedNumber number={contact.phoneNumber} />
        </div>
      );
    },
  },
  {
    heading: "Name",
    renderCell: (contact) => {
      return (
        <Typography
          style={{ fontFamily: "Sofia", textAlign: "left", fontSize: 14 }}
        >
          {contact?.name ?? "-"}
        </Typography>
      );
    },
  },
  {
    heading: "Company",
    renderCell: (contact) => {
      return (
        <Typography
          style={{ fontFamily: "Sofia", textAlign: "left", fontSize: 14 }}
        >
          {contact?.company ?? "-"}
        </Typography>
      );
    },
  },
];
